import { default as main } from './index.js';
import * as ytmpl from './index.js';

export = Object.assign(main, { ...ytmpl });
